import React, { useState, useMemo } from 'react';
import { ChevronDown } from 'lucide-react';
import './MapSection.css';

// Map Data based on the provided image
type ProgramType = 'P3PD' | 'Penguatan P2MI BK' | 'PPA' | 'Kemala';

interface MapMarker {
  id: string;
  name: string;
  region: string;
  x: number; // percentage X
  y: number; // percentage Y
  programs: ProgramType[];
}

const mapMarkers: MapMarker[] = [
  // Sumatra
  { id: '1', name: 'Solok Selatan', region: 'Sumatera', x: 17.5, y: 45.5, programs: ['Penguatan P2MI BK'] },
  { id: '2', name: 'Tanjung Jabung Timur', region: 'Sumatera', x: 22.16, y: 43.09, programs: ['Kemala'] },
  { id: '3', name: 'Lampung Timur', region: 'Sumatera', x: 25.5, y: 63, programs: ['PPA'] },

  // Java
  { id: '4', name: 'Sukabumi', region: 'Jawa', x: 28.48, y: 73.11, programs: ['PPA'] },
  { id: '5', name: 'Karawang', region: 'Jawa', x: 29.5, y: 71, programs: ['P3PD', 'Penguatan P2MI BK'] },
  { id: '6', name: 'Purwakarta', region: 'Jawa', x: 30.5, y: 72.5, programs: ['PPA'] },
  { id: '7', name: 'Majalengka', region: 'Jawa', x: 32, y: 74, programs: ['PPA'] },
  { id: '8', name: 'Indramayu', region: 'Jawa', x: 32.1, y: 71, programs: ['PPA'] },
  { id: '9', name: 'Kuningan', region: 'Jawa', x: 33.5, y: 74, programs: ['P3PD'] },
  { id: '10', name: 'Cilacap', region: 'Jawa', x: 33.5, y: 78, programs: ['Kemala'] },
  { id: '11', name: 'Kebumen', region: 'Jawa', x: 35, y: 78, programs: ['P3PD', 'Penguatan P2MI BK'] },
  { id: '12', name: 'Magelang', region: 'Jawa', x: 36, y: 75.5, programs: ['P3PD'] },
  { id: '13', name: 'Kulon Progo', region: 'Jawa', x: 36, y: 78, programs: ['PPA'] },
  { id: '14', name: 'Gunungkidul', region: 'Jawa', x: 37.5, y: 79, programs: ['PPA'] },
  { id: '15', name: 'Boyolali', region: 'Jawa', x: 37, y: 76, programs: ['P3PD'] },
  { id: '16', name: 'Sukoharjo', region: 'Jawa', x: 38, y: 76.5, programs: ['P3PD'] },
  { id: '17', name: 'Wonogiri', region: 'Jawa', x: 38.5, y: 77, programs: ['P3PD', 'PPA'] },
  { id: '18', name: 'Kendal', region: 'Jawa', x: 36, y: 73.5, programs: ['P3PD'] },
  { id: '19', name: 'Gresik', region: 'Jawa', x: 39, y: 75.5, programs: ['PPA'] },
  { id: '20', name: 'Blitar', region: 'Jawa', x: 38.5, y: 80, programs: ['P3PD'] },
  { id: '21', name: 'Malang', region: 'Jawa', x: 39.5, y: 80, programs: ['P3PD'] },
  { id: '22', name: 'Lumajang', region: 'Jawa', x: 40.5, y: 80, programs: ['P3PD'] },
  { id: '23', name: 'Bangkalan', region: 'Jawa', x: 40, y: 72.5, programs: ['PPA'] },

  // Kalimantan
  { id: '24', name: 'Kubu Raya', region: 'Kalimantan', x: 33.5, y: 40, programs: ['P3PD'] },
  { id: '25', name: 'Kapuas Hulu', region: 'Kalimantan', x: 37, y: 33, programs: ['PPA'] },
  { id: '26', name: 'Pulang Pisau', region: 'Kalimantan', x: 42, y: 52, programs: ['P3PD'] },
  { id: '27', name: 'Kapuas', region: 'Kalimantan', x: 43.5, y: 49.5, programs: ['PPA'] },
  { id: '28', name: 'Banjar', region: 'Kalimantan', x: 44, y: 56, programs: ['P3PD'] },
  { id: '29', name: 'HST', region: 'Kalimantan', x: 45, y: 51.5, programs: ['P3PD'] },
  { id: '30', name: 'Kutai Kartanegara', region: 'Kalimantan', x: 47.5, y: 40, programs: ['P3PD'] },
  { id: '31', name: 'Kutai Timur', region: 'Kalimantan', x: 50.5, y: 30, programs: ['P3PD'] },
  { id: '32', name: 'Tana Tidung', region: 'Kalimantan', x: 48.88, y: 17.16, programs: ['P3PD'] },
  { id: '33', name: 'Nunukan', region: 'Kalimantan', x: 47.61, y: 17.52, programs: ['P3PD'] },

  // Sulawesi
  { id: '34', name: 'Donggala', region: 'Sulawesi', x: 53.5, y: 38, programs: ['Penguatan P2MI BK'] },
  { id: '35', name: 'Tojo Una-Una', region: 'Sulawesi', x: 56.5, y: 43, programs: ['PPA'] },

  // Bali & Nusa Tenggara
  { id: '36', name: 'Karangasem', region: 'Bali, NTB & NTT', x: 44.8, y: 82, programs: ['P3PD'] },
  { id: '37', name: 'Gianyar', region: 'Bali, NTB & NTT', x: 44.5, y: 82.5, programs: ['Kemala'] },
  { id: '38', name: 'Klungkung', region: 'Bali, NTB & NTT', x: 44.2, y: 82, programs: ['PPA'] },
  { id: '39', name: 'Lombok Utara', region: 'Bali, NTB & NTT', x: 46.5, y: 81.5, programs: ['P3PD'] },
  { id: '40', name: 'Lombok Timur', region: 'Bali, NTB & NTT', x: 47, y: 81.5, programs: ['Penguatan P2MI BK'] },
  { id: '41', name: 'Sumbawa', region: 'Bali, NTB & NTT', x: 48.5, y: 82.5, programs: ['PPA'] },
  { id: '42', name: 'Flores Timur', region: 'Bali, NTB & NTT', x: 60, y: 80, programs: ['Penguatan P2MI BK'] },
  { id: '43', name: 'Lembata', region: 'Bali, NTB & NTT', x: 62, y: 80, programs: ['PPA'] },
  { id: '44', name: 'Kupang', region: 'Bali, NTB & NTT', x: 61, y: 89.5, programs: ['Penguatan P2MI BK'] },

  // Papua
  { id: '45', name: 'Sorong', region: 'Papua', x: 76.8, y: 42, programs: ['PPA'] },
];

const programColors: Record<ProgramType, string> = {
  'P3PD': '#bda135', // Gold/Yellow
  'Penguatan P2MI BK': '#d92c2c', // Red
  'PPA': '#4e62d9', // Blue
  'Kemala': '#96d962' // Light Green
};

const MapSection: React.FC = () => {
  const [activeMarker, setActiveMarker] = useState<MapMarker | null>(null);
  const [expandedRegion, setExpandedRegion] = useState<string | null>(null);

  const regionGroups = useMemo(() => {
    const groups: Record<string, MapMarker[]> = {};
    const regionOrder = [
      'Sumatera',
      'Jawa',
      'Kalimantan',
      'Sulawesi',
      'Bali, NTB & NTT',
      'Papua'
    ];
    mapMarkers.forEach(m => {
      const region = m.region || 'Lainnya';
      if (!groups[region]) groups[region] = [];
      groups[region].push(m);
    });
    const ordered: Record<string, MapMarker[]> = {};
    regionOrder.forEach(r => {
      if (groups[r]) ordered[r] = groups[r];
    });
    Object.keys(groups).forEach(r => {
      if (!ordered[r]) ordered[r] = groups[r];
    });
    return ordered;
  }, []);

  const handleMapClick = (_e: React.MouseEvent<HTMLDivElement>) => {
    // Reserved for future map interaction features
  };

  return (
    <section className="MapSection_section">
      <div className="container">
        <div className="MapSection_header animate-fade-up">
          <span className="MapSection_label">Jangkauan Kami</span>
          <h2 className="MapSection_title">Wilayah Pendampingan Lakpesdam PBNU</h2>
          <p className="MapSection_description">
            Tersebar di 34 Provinsi, 46 Kabupaten, dan 307 Desa di seluruh penjuru Nusantara.
          </p>

        </div>

        <div className="MapSection_contentWrapper animate-fade-up" style={{ animationDelay: '0.2s' }}>

          <div className="MapSection_mapArea" onClick={handleMapClick} style={{ cursor: 'crosshair' }}>
            <img
              src="/assets/indonesia-map-blank.svg"
              alt="Peta Indonesia"
              className="MapSection_mapImage"
              width="800"
              height="600"
              onError={(e) => {
                // Fallback if SVG is missing, rendering a simple generic background block for pins to overlay
                (e.target as HTMLImageElement).style.display = 'none';
                (e.target as HTMLImageElement).parentElement?.classList.add('MapSection_mapFallback');
              }}
            />

            {/* Map Markers */}
            {mapMarkers.map((marker) => (
              <div
                key={marker.id}
                className="MapSection_pinWrapper"
                style={{ left: `${marker.x}%`, top: `${marker.y}%` }}
                onMouseEnter={() => setActiveMarker(marker)}
                onMouseLeave={() => setActiveMarker(null)}
                onFocus={() => setActiveMarker(marker)}
                onBlur={() => setActiveMarker(null)}
                tabIndex={0}
                role="button"
                aria-label={`${marker.name}: ${marker.programs.join(', ')}`}
              >
                <div
                  className={`MapSection_pin ${activeMarker?.id === marker.id ? 'active' : ''}`}
                  style={{ backgroundColor: programColors[marker.programs[0]] }}
                />

                {/* Tooltip */}
                <div className={`MapSection_tooltip ${activeMarker?.id === marker.id ? 'visible' : ''}`}>
                  <h4 className="MapSection_tooltipTitle">{marker.name}</h4>
                  <ul className="MapSection_tooltipPrograms">
                    {marker.programs.map((prog, i) => (
                      <li key={i} style={{ color: programColors[prog] }}>
                        <span className="MapSection_bullet" style={{ backgroundColor: programColors[prog] }} />
                        {prog}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>

          {/* Mobile List View (hidden on desktop via CSS) */}
          <div className="MapSection_mobileList">
            {Object.entries(regionGroups).map(([region, markers]) => (
              <div key={region} className="MapSection_mobileRegion">
                <div
                  className="MapSection_mobileRegionHeader"
                  onClick={() => setExpandedRegion(expandedRegion === region ? null : region)}
                >
                  <span>{region} ({markers.length} lokasi)</span>
                  <ChevronDown size={18} style={{transform: expandedRegion === region ? 'rotate(180deg)' : 'rotate(0deg)'}} />
                </div>
                {expandedRegion === region && (
                  <div className="MapSection_mobileRegionItems">
                    {markers.map(marker => (
                      marker.programs.map((prog, i) => (
                        <span key={`${marker.id}-${i}`} className="MapSection_mobilePin">
                          <span className="MapSection_mobileDot" style={{backgroundColor: programColors[prog]}} />
                          {marker.name} — {prog}
                        </span>
                      ))
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="MapSection_sidebar">
            <div className="MapSection_legend">
              <h3 className="MapSection_legendTitle">Keterangan Program</h3>
              <ul className="MapSection_legendList">
                {Object.entries(programColors).map(([program, color]) => (
                  <li key={program} className="MapSection_legendItem">
                    <span className="MapSection_legendColor" style={{ backgroundColor: color }}></span>
                    <span className="MapSection_legendText">{program}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="MapSection_stats">
              <div className="MapSection_statItem">
                <span className="MapSection_statNumber" translate="no">34</span>
                <span className="MapSection_statLabel">Provinsi</span>
              </div>
              <div className="MapSection_statItem">
                <span className="MapSection_statNumber" translate="no">46</span>
                <span className="MapSection_statLabel">Kabupaten</span>
              </div>
              <div className="MapSection_statItem">
                <span className="MapSection_statNumber" translate="no">307</span>
                <span className="MapSection_statLabel">Desa</span>
              </div>
            </div>
            <p className="MapSection_footnote">
              Regional Board (PWNU): Provincial level, with 38 regions across Indonesia.<br />
              Branch Board (PCNU): District/city level, with 500+ branches.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default MapSection;
